import React, { useEffect, useState } from "react";
import { Tabs, Modal, Input, message, Button } from "antd";
import Register from "./Registeration/Register";
import Seller from "./seller/index";
import Buyer from "./buyer/index";
import BuyerAgent from "./BuyerAgent/index";
import ListnigCommision from "./ListingCommission/index";
import ExtensionofTime from "./ExtensionOftime/index";
import DualAgency from "./DualAgency/index";
import ReleaseFromContracts from "./ReleaseFromContracts/index";
import TenantalFee from "./TenantFee/index";
import RentalAgent from "./RentalAgreement/index";
import Residential from "./ResidentialRental/index";
import FinalWalk from "../pages/FinalWalk/index";
import SecurityDeposit from "../pages/securityDeposit/index";
import NewAgents from "../pages/newAgents/index";
import LoadingOverlay from "react-loading-overlay";

const Index = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [selectedTab, setSelectedTab] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isActive, setActive] = useState(false);

  const showModal = (tabKey) => {
    if (!isAuthorized) {
      setSelectedTab(tabKey);
      setIsModalVisible(true);
    }
  };

  // Handle password verification
  const handleOk = () => {
    if (password === "agents") {
      // message.success("Admin access granted!");
      setIsModalVisible(false);
      setIsAuthorized(true);
      localStorage.setItem("user", JSON.stringify({ user: true }));
    } else {
      message.error("Incorrect password!");
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      showModal();
    } else {
      setIsAuthorized(true);
    }
  }, []);

  return (
    <LoadingOverlay
      active={isActive}
      spinner
      text="Generating Pdf..."
      className={`${isActive ? "fullscreen-overlay" : ""}`}
    >
      <div style={{ margin: "10px 12px" }}>
        <Tabs onChange={(key) => showModal(key)}>
          <Tabs.TabPane tab="Contract To Purchase" key="1">
            <Register setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Exclusive Buyer Agency" key="2">
            <Buyer setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Listing Agreement" key="3">
            <Seller setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Buyer Agent Commission" key="4">
            <BuyerAgent setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Listing Commission Statement" key="5">
            <ListnigCommision setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Extension Of Time" key="6">
            <ExtensionofTime setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Dual Agency" key="7">
            <DualAgency setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Release from contract" key="8">
            <ReleaseFromContracts setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tenant Rental Fee" key="9">
            <TenantalFee setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Rental listing agreement" key="10">
            <RentalAgent setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Residential Rental agreement" key="11">
            <Residential setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Final Walk" key="12">
            <FinalWalk setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Security Deposit" key="13">
            <SecurityDeposit setActive={setActive} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="New Agents" key="14">
            <NewAgents setActive={setActive} />
          </Tabs.TabPane>
        </Tabs>
        <Modal
          open={isModalVisible}
          onOk={handleOk}
          maskClosable={false}
          footer={null}
          closeIcon={false}
        >
          <div style={{ padding: "2rem" }}>
            <h2 style={{ textAlign: "center" }}>Enter password</h2>
            <Input.Password
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button htmlType="submit" onClick={handleOk} type="primary">
                Submit
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </LoadingOverlay>
  );
};

export default Index;
